import React, { useEffect, useMemo } from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import {
  useAppDispatch,
  useAppSelector
} from '@verzekeringapp-mono/shared/src/hooks/state'
import { getUser } from '@verzekeringapp-mono/shared/src/state/selectors/user'
import ProfileNavigationButton from './components/profile_navigation_button'
import { profileTiles } from '@verzekeringapp-mono/shared/src/utils/tiles_data/profile_tiles.data'
import { useNavigate } from 'react-router-dom'
import { getResourceAuthorization } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import { isMainUser } from '@verzekeringapp-mono/shared/src/utils/resource_utils'
import useRelationMutation from '@verzekeringapp-mono/shared/src/hooks/use_relation_mutation'
import { pruneExpiredOverrides } from '@verzekeringapp-mono/shared/src/state/slices/resource_authorization_slice'
import useAuthentication from '@verzekeringapp-mono/shared/src/hooks/use_authentication'

const ProfileScreen: React.FC = () => {
  const user = useAppSelector(getUser)
  const dispatch = useAppDispatch()
  const resourceAuthorization = useAppSelector(getResourceAuthorization)
  const mainUser = useMemo(() => isMainUser(resourceAuthorization?.roles), [resourceAuthorization?.roles])

  const navigate = useNavigate()
  const { getPendingMutations } = useRelationMutation()
  const { logout } = useAuthentication()

  useEffect(() => {
    dispatch(pruneExpiredOverrides())
    getPendingMutations()
  }, [])

  return (
    <ScreenWrapper>
      <div className='flex flex-col flex-1 items-center mb-32'>
        <p className='text-[20px] text-text-brand'>{user?.firstName}</p>

        <p className='text-[14px] text-text-secondary'>
          Combinummer: {resourceAuthorization?.combiNumber}
        </p>

        <p className='mb-8 text-[14px] text-text-secondary'>
          {mainUser ? 'Hoofdgebruiker' : 'Subgebruiker'}
        </p>

        <div className='md:w-2/6 w-full flex flex-col'>
          {profileTiles(mainUser).map((tile)=> (
            <ProfileNavigationButton
              key={`profile-tile-${tile.href}`}
              data={tile}
            />
          ))}

          <ProfileNavigationButton
            onPress={async () => {
              await logout()
              navigate('/')
            }}
            data={{
              href: '/',
              icon: 'user-times',
              title: 'Uitloggen'
            }}
          />
        </div>
      </div>
    </ScreenWrapper>
  )
}

export default ProfileScreen
